var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "py-10", attrs: { id: "session-history" } }, [
    _c(
      "div",
      { staticClass: "mb-6 mx-10" },
      [
        _c("BlTextTitle4", { attrs: { text: "Session history" } }),
        _vm._v(" "),
        _c("BlTextBody2", { attrs: { text: _vm.description } }),
        _vm._v(" "),
        _vm.therapistName
          ? _c(
              "div",
              { staticClass: "flex items-center gap-2 mt-2" },
              [
                _c("BlIcon", {
                  staticClass: "w-6 h-6",
                  attrs: { icon: "account-multiple" }
                }),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass:
                      "h-8 px-2 flex items-center gap-1 rounded text-success bg-success-100"
                  },
                  [_c("BlTextBody2", { attrs: { text: _vm.therapistName } })],
                  1
                )
              ],
              1
            )
          : _vm._e()
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "grid grid-cols-2 items-center gap-4 mb-6 px-10" },
      [
        _c("BlInputFilterAdvance", {
          attrs: {
            activeLabel: _vm.activeFilterDate,
            input: _vm.sessionFilterDateInput
          },
          on: { changed: _vm.onChangeFilter }
        }),
        _vm._v(" "),
        _c("BlInputSelect", {
          attrs: { input: _vm.sessionFilterClientInput },
          on: { changed: _vm.onChangeFilter }
        })
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "flex items-center gap-4 px-10 mb-6" },
      [
        _c("BlTextBody2", {
          staticClass: "flex-shrink-0",
          attrs: { text: "Group by" }
        }),
        _vm._v(" "),
        _vm._l(_vm.groupOptions, function(opt) {
          return _c(
            "button",
            {
              key: opt.value,
              staticClass:
                "w-full py-1 rounded border text-sm outline-none hover:bg-hover-state",
              class:
                _vm.groupBy === opt.value
                  ? "border-light-purple text-light-purple"
                  : "border-grey-200",
              on: {
                click: function($event) {
                  return _vm.onChangeGroup(opt.value)
                }
              }
            },
            [_vm._v("\n      " + _vm._s(opt.label) + "\n    ")]
          )
        })
      ],
      2
    ),
    _vm._v(" "),
    _vm.pageLoading
      ? _c("div", { staticClass: "h-128 grid place-items-center" }, [
          _c("div", { staticClass: "blum-loader" })
        ])
      : _c("div", [
          _c(
            "div",
            { staticClass: "mb-6 mx-10" },
            [
              _c("div", { staticClass: "text-xs text-grey-400 mb-2" }, [
                _vm._v("Number of session")
              ]),
              _vm._v(" "),
              _c("BarChart", {
                key: "bar-chart",
                staticClass: "w-full",
                attrs: {
                  "chart-data": _vm.collection,
                  options: _vm.chartoptions
                }
              }),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "text-xs text-grey-400 mb-2 pl-6 text-center" },
                [_vm._v("\n        Date of session\n      ")]
              )
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "w-full h-px bg-grey-200 mb-5" }),
          _vm._v(" "),
          _c("div", { staticClass: "mb-6 mx-10" }, [
            _c(
              "div",
              { staticClass: "mb-4 flex items-center justify-between" },
              [
                _c(
                  "div",
                  { staticClass: "flex items-center gap-2" },
                  [
                    _c("BlTextBody2", { attrs: { text: "Showing" } }),
                    _vm._v(" "),
                    _c("BlBubbleCount", {
                      attrs: {
                        count: _vm.sessionHistories.reduce(function(acc, obj) {
                          return acc + obj.sessions.length
                        }, 0)
                      }
                    }),
                    _vm._v(" "),
                    _c("BlTextBody2", { attrs: { text: "session" } })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  [
                    _c("BlInputSelect", {
                      attrs: { input: _vm.sessionHistorySortInput },
                      on: { changed: _vm.inputHandler }
                    })
                  ],
                  1
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "table",
              { attrs: { id: "blum-table" } },
              [
                _c("thead", [
                  _c("tr", [
                    _c(
                      "td",
                      { staticClass: "capitalize" },
                      [
                        _c("BlTextSubtitle2", {
                          attrs: {
                            text: _vm.groupBy === "day" ? "Date" : _vm.groupBy
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _vm.groupBy !== "day"
                      ? _c(
                          "td",
                          [_c("BlTextSubtitle2", { attrs: { text: "Date" } })],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "td",
                      { staticClass: "flex-shrink-0" },
                      [_c("BlTextSubtitle2", { attrs: { text: "Client" } })],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "td",
                      [_c("BlTextSubtitle2", { attrs: { text: "Duration" } })],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "td",
                      [_c("BlTextSubtitle2", { attrs: { text: "Target" } })],
                      1
                    )
                  ])
                ]),
                _vm._v(" "),
                !_vm.sessionTable.length
                  ? _c("tbody", [
                      _c("tr", [
                        _c(
                          "td",
                          {
                            staticClass: "text-center text-sm text-grey-400",
                            attrs: { colspan: _vm.groupBy === "day" ? 4 : 5 }
                          },
                          [
                            _vm._v(
                              "\n              Session not found\n            "
                            )
                          ]
                        )
                      ])
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm._l(_vm.sessionTable, function(sessionBody, bodyIndex) {
                  return _c(
                    "tbody",
                    { key: bodyIndex },
                    _vm._l(sessionBody.sessions, function(session, index) {
                      return _c("tr", { key: index }, [
                        index === 0
                          ? _c(
                              "td",
                              {
                                staticClass:
                                  "bg-grey-100 text-grey-400 border-r py-2",
                                attrs: {
                                  rowspan: sessionBody.number_of_session
                                }
                              },
                              [
                                _c(
                                  "span",
                                  {
                                    staticClass: "flex items-center gap-2 mb-1"
                                  },
                                  [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(
                                          _vm._f("moment")(
                                            sessionBody.date,
                                            _vm.groupBy === "day"
                                              ? "dddd"
                                              : _vm.groupBy === "year"
                                              ? "YYYY"
                                              : "MMMM"
                                          )
                                        ) +
                                        "\n                "
                                    ),
                                    _c("BlBubbleCount", {
                                      attrs: {
                                        count:
                                          sessionBody.number_of_session || 0
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c("span", [
                                  _vm._v(
                                    _vm._s(_vm.dateColumn(sessionBody.date))
                                  )
                                ])
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.groupBy !== "day"
                          ? _c("td", { staticClass: "text-grey" }, [
                              _vm._v(
                                "\n              " +
                                  _vm._s(
                                    _vm._f("moment")(
                                      session.end_time,
                                      "DD/MM/YYYY"
                                    )
                                  ) +
                                  "\n            "
                              )
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _c("td", { staticClass: "text-grey" }, [
                          _c(
                            "div",
                            {
                              staticClass: "truncate",
                              class: _vm.groupBy === "day" ? "w-70" : "w-22",
                              attrs: {
                                title: session.client
                                  ? session.client.name
                                  : "-"
                              }
                            },
                            [
                              _vm._v(
                                "\n                " +
                                  _vm._s(
                                    session.client ? session.client.name : "-"
                                  ) +
                                  "\n              "
                              )
                            ]
                          )
                        ]),
                        _vm._v(" "),
                        _c("td", { staticClass: "text-grey-400" }, [
                          _vm._v(
                            "\n              " +
                              _vm._s(session.current_recording_time[1]) +
                              "\n            "
                          )
                        ]),
                        _vm._v(" "),
                        _c("td", { staticClass: "text-grey-400 text-center" }, [
                          _vm._v(
                            "\n              " +
                              _vm._s(session.number_of_measurements || 0) +
                              "\n            "
                          )
                        ])
                      ])
                    }),
                    0
                  )
                })
              ],
              2
            )
          ])
        ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2ea0f7d2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2ea0f7d2","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/profile/TabSession.vue
// module id = null
// module chunks = 